import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NftStatisticTOResponse } from 'api/models/nft-statistic-toresponse';
import { DashboardService } from 'dashboard/services/dashboard.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-street-progress',
  templateUrl: './street-progress.component.html',
  styleUrls: ['./street-progress.component.scss'],
})
export class StreetProgressComponent implements OnDestroy, OnInit {
  nfts: NftStatisticTOResponse = {
    totalNfts: 0,
  };
  @ViewChild('plan1', { static: true }) plan1Ref!: ElementRef<HTMLElement>;
  @ViewChild('plan2', { static: true }) plan2Ref!: ElementRef<HTMLElement>;
  @ViewChild('plan3', { static: true }) plan3Ref!: ElementRef<HTMLElement>;
  @ViewChild('plan4', { static: true }) plan4Ref!: ElementRef<HTMLElement>;
  @ViewChild('plan5', { static: true }) plan5Ref!: ElementRef<HTMLElement>;

  private destroy$ = new Subject();

  constructor(private render: Renderer2, private dashboardService: DashboardService) {}

  ngOnInit(): void {
    this.dashboardService
      .getStreetsProgress()
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        this.nfts = res;
        this.calculateProgress();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private calculateProgress(): void {
    const buildings = this.nfts.elements?.find(x => x.type === 'BUILDING');
    if (this.plan1Ref && this.plan2Ref && this.plan4Ref && this.plan4Ref) {
      const plan1Percent = ((this.nfts?.totalZone1Price || 0) / (this.nfts?.totalPrice || 0)) * 100;
      const plan2Percent = ((this.nfts?.totalZone2Price || 0) / (this.nfts?.totalPrice || 0)) * 100;
      const plan3Percent = ((this.nfts?.totalZone3Price || 0) / (this.nfts?.totalPrice || 0)) * 100;
      const plan4Percent = ((this.nfts?.totalZone4Price || 0) / (this.nfts?.totalPrice || 0)) * 100;
      const plan5Percent = ((buildings?.totalZone5Price || 0) / (this.nfts?.totalPrice || 0)) * 100;

      this.render.setStyle(this.plan1Ref.nativeElement, 'width', `${plan1Percent}%`);
      this.render.setStyle(this.plan2Ref.nativeElement, 'width', `${plan2Percent}%`);
      this.render.setStyle(this.plan3Ref.nativeElement, 'width', `${plan3Percent}%`);
      this.render.setStyle(this.plan4Ref.nativeElement, 'width', `${plan4Percent}%`);
      this.render.setStyle(this.plan5Ref.nativeElement, 'width', `${plan5Percent}%`);

      if (plan1Percent === 0) {
        this.plan1Ref.nativeElement.remove();
      }

      if (plan2Percent === 0) {
        this.plan2Ref.nativeElement.remove();
      }

      if (plan3Percent === 0) {
        this.plan3Ref.nativeElement.remove();
      }

      if (plan4Percent === 0) {
        this.plan4Ref.nativeElement.remove();
      }

      if(plan5Percent === 0) {
        this.plan5Ref.nativeElement.remove();
      }
    }
  }
}
